export default function noop() {}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-simple-maps/node_modules/d3-geo/src/noop.js
// module id = qme9
// module chunks = 0